import React from "react";
import { checkPasswordRules } from "../utils/passwordUtils";

const PasswordRules = ({ password }) => {
  const passwordRules = checkPasswordRules(password);

  return (
    <div className="password-rules">
      <div
        className={
          passwordRules.length ? "password-rule-valid" : "password-rule-invalid"
        }
      >
        At least 8 characters
      </div>
      <div
        className={
          passwordRules.upper ? "password-rule-valid" : "password-rule-invalid"
        }
      >
        At least one uppercase letter
      </div>
      <div
        className={
          passwordRules.lower ? "password-rule-valid" : "password-rule-invalid"
        }
      >
        At least one lowercase letter
      </div>
      <div
        className={
          passwordRules.number ? "password-rule-valid" : "password-rule-invalid"
        }
      >
        At least one number
      </div>
    </div>
  );
};

export default PasswordRules;
